import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";

/**
 * Charge Edit Form Component
 */
const ChargeEditForm = ({
    store_domain,
    variable_charge,
    fixed_charge,
    onInputChange,
    onSubmit,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={4}>
                    <Input
                        value={store_domain}
                        type="text"
                        name="store_domain"
                        className="form-control"
                        id="horizontal-store_domain-Input"
                        onChange={onInputChange}
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-variable_charge-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Variable Charge(%)
                </Label>
                <Col sm={4}>
                    <Input
                        value={variable_charge}
                        type="number"
                        name="variable_charge"
                        className="form-control"
                        id="horizontal-variable_charge-Input"
                        onChange={onInputChange}
                        required
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-fixed_charge-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Fixed Charge($)
                </Label>
                <Col sm={4}>
                    <Input
                        value={fixed_charge}
                        type="number"
                        name="fixed_charge"
                        className="form-control"
                        id="horizontal-fixed_charge-Input"
                        onChange={onInputChange}
                        required
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4 justify-content-end">
                <Col sm={10}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Update
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

ChargeEditForm.propTypes = {
    store_domain: PropTypes.string.isRequired,
    variable_charge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    fixed_charge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default ChargeEditForm;

